<template>
  <div>
    <div
      class="product-window group-con"
      :class="attr.cartAttr === true ? 'on' : ''"
      :style="'padding-bottom:' + (isShowBtn ? '0' : '')"
    >
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.productSelect.store_name }}
          </div>
          <div class="money font-color-red">
            ￥<span class="num">{{ attr.productSelect.price * attr.productSelect.cart_num }}</span>
            <span class="stock" v-if="isShow">
              库存: {{ attr.productSelect.stock }}
            </span>
            <!-- <span class="stock" v-else>
              限量:
              {{
                attr.productSelect.quota_show
                  ? attr.productSelect.quota_show
                  : 0
              }}
            </span> -->
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div
          class="item"
          v-for="(item, indexw) in attr.productAttr"
          :key="indexw"
        >
          <div class="title">{{ item.attr_name }}</div>
          <div class="listn acea-row row-middle">
            <div
              class="itemn"
              :class="item.index === itemn.attr ? 'on' : ''"
              v-for="(itemn, indexn) in item.attr_value"
              @click="tapAttr(indexw, itemn.attr)"
              :key="indexn"
            >
              {{ itemn.attr }}
            </div>
          </div>
        </div>
      </div>
      <div class="cart" style="padding-bottom: 30px;">
        <div class="title">数量</div>
        <div class="carnum acea-row row-left">
          <div
            class="item reduce"
            :class="attr.productSelect.cart_num <= 1 ? 'on' : ''"
            @click="CartNumDes"
          >
            -
          </div>
          <div class="item num" style="width: 1.1rem;">
            <input
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="off"
              :value="attr.productSelect.cart_num"
              class="ipt_num"
              @input="onCartNumInput"
              @blur="onCartNumBlur"
            />
          </div>
          <div
            v-if="iSplus"
            class="item plus"
            :class="
              attr.productSelect.cart_num >= attr.productSelect.stock
                ? 'on'
                : ''
            "
            @click="CartNumAdd"
          >
            +
          </div>
          <div
            v-else
            class="item plus"
            :class="
              attr.productSelect.cart_num >= attr.productSelect.product_stock ||
              attr.productSelect.cart_num >= attr.productSelect.quota_show ||
              attr.productSelect.cart_num >= attr.productSelect.num
                ? 'on'
                : ''
            "
            @click="CartNumAdd"
          >
            +
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="isShowBtn">
        <div
          class="teamBnt bg-color-red"
          @click="openAlone"
          v-if="
            attr.productSelect.quota > 0 && attr.productSelect.product_stock > 0
          "
        >
          立即参团
        </div>
        <div class="teamBnt bg-color-hui" v-else>已售罄</div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="attr.cartAttr === false"
      @click="closeAttr"
    ></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => {}
    },
    iSplus: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {};
  },
  computed: {
    isShow() {
      return this.$route.path.indexOf("detail") === 1;
    },
    isShowBtn() {
      return this.$route.path.indexOf("group_rule") != -1;
    }
  },
  mounted: function() {},
  methods: {
    openAlone() {
      this.$emit("changeFun", { action: "goPay", value: false });
    },
    closeAttr: function() {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function(indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function() {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_value.length; j++) {
          if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
            value.push(productAttr[i].attr_value[j].attr);
          }
        }
      }
      return value;
    },
    /** 与「+」按钮一致的可选上限；0 表示不按库存类字段封顶（仍保证最小为 1） */
    getCartNumMaxCap: function() {
      const p = this.attr.productSelect;
      if (this.iSplus) {
        const s = parseInt(p.stock, 10);
        return s > 0 ? s : 0;
      }
      const vals = [
        parseInt(p.product_stock, 10),
        parseInt(p.quota_show, 10),
        parseInt(p.num, 10)
      ].filter(function(v) {
        return !isNaN(v) && v > 0;
      });
      if (!vals.length) return 0;
      return Math.min.apply(null, vals);
    },
    /** 解析为大于 0 的整数（去掉小数与小数点后内容） */
    parsePositiveInteger: function(raw) {
      if (raw === "" || raw === null || raw === undefined) return NaN;
      let s = String(raw);
      const dot = s.indexOf(".");
      if (dot >= 0) s = s.substring(0, dot);
      s = s.replace(/\D/g, "");
      if (s === "") return NaN;
      const n = parseInt(s, 10);
      if (!isFinite(n) || n < 1) return NaN;
      const max = this.getCartNumMaxCap();
      if (max > 0 && n > max) return max;
      return n;
    },
    ensureCartNum: function(raw) {
      let n = this.parsePositiveInteger(
        raw === "" || raw === null || raw === undefined ? "1" : raw
      );
      if (!isFinite(n) || n < 1) n = 1;
      return n;
    },
    onCartNumInput: function(e) {
      const raw = e.target.value;
      if (raw === "") {
        this.$set(this.attr.productSelect, "cart_num", "");
        return;
      }
      const n = this.ensureCartNum(raw);
      this.$set(this.attr.productSelect, "cart_num", n);
      this.$nextTick(function() {
        if (e.target.value !== String(n)) {
          e.target.value = String(n);
        }
      });
    },
    onCartNumBlur: function(e) {
      const n = this.ensureCartNum(
        this.attr.productSelect.cart_num === ""
          ? "1"
          : this.attr.productSelect.cart_num
      );
      this.$set(this.attr.productSelect, "cart_num", n);
      if (e && e.target) e.target.value = String(n);
    }
  }
};
</script>
<style scoped>
.joinCart {
  width: 80%;
  height: 0.76rem;
  line-height: 0.76rem;
  text-align: center;
}
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.54rem;
  text-align: center;
}
</style>
